import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useField } from "formik";
import Input from "styled/input.js";
import axios from "apis/axios";
import toast from "react-hot-toast";
import ViewFileArea from "./ViewFileArea";
import { compressFile } from "utils/ImageCompression";

const InputField = ({ label, desable, required, inputClass, ...props }) => {
  const [field, meta] = useField(props);
  const [files, setFiles] = useState(props.type ==="file" && meta.value ?  typeof meta.value === "object" ? [...meta.value] : [meta.value]: []);
  const [uploadProgress, setUploadProgress] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  useMemo(()=>{
    if(props.type ==="file"){
      setFiles(meta.value)
      if(typeof meta.value === "object"){ meta.value?.map((key, index)=> {
        //console.log("INDEX", {key, index});
        console.log(key)
        setUploadProgress({...uploadProgress, [index]:{ percentage: 100, name: key.split("/")?.slice(-1)[0]}})})
    }
    if(meta.value)  setFiles(typeof meta.value === "object" ? [...meta.value] : [meta.value ?? []])
  }
  }, [field.value])

  const handleFileChange = async (e) => {
    let file = e.target.files[0];

    if (props.validateFileType) {
      const allowedTypes = props?.accept?.split(",").map((type) => type.trim());
      if (!allowedTypes.includes(file.type)) {
        throw { message: `Invalid file type. Allowed types are: ${allowedTypes.join(", ")}` };
      }
    }

    let formData = new FormData();
    try {
      if (file) {

        console.log("FILE SIZE", file?.size);

        const currentLength = files?.length;
        if(props.limit && currentLength >= props.limit){
          throw {message: "Maximum limit of files: " + props.limit + ", exceed"}
        }

        console.log(file)

        if(props.compressImage && file.size > props.maxSize){
          
          file = await compressFile(file);
          console.log(file)
        }

        formData.append("file", file);
        setIsLoading(true);
     
        const _id = `file_${currentLength}`;
        let bar = document.getElementById(_id);
        let config = {
          onUploadProgress: (progressEvent) => {
            const percentage = (progressEvent.loaded / progressEvent.total) * 100;
            bar?.setAttribute("value", percentage);
            setUploadProgress({
              ...uploadProgress,
              [currentLength]: { percentage, name: file.name },
            });
          },
        };
        let response = await axios({
          method: "post",
          url: `/file/upload`,
          data: formData,
        });
        let url = response.data.file?.location;
        if(url){
          if(files?.length) setFiles([...files, url]);
          else  setFiles([url])
          //console.log({url})
          props.formik.setFieldValue(field.name, [...files, url]);
          //console.log("IMAGE UPLOADED", props.formik.values[field.name]);
        }
      }
    } catch (error) {
      //console.log({error});
      const currentLength = files?.length;
      const data = {...uploadProgress}
      if(data) delete data[currentLength]
      setUploadProgress(data)
      toast.error(error.message);
    }finally {
      setIsLoading(false);
    }
};

  

  const deleteFile = (index)=>{
    // console.log("value", field.value)
    const val = typeof field.value === "object" ? [...field.value] :  [field.value]
    props.formik.setFieldValue(field.name, [...val.filter(file=>file!==field.value[index])]);
  }

  return (
    <div className=" flex flex-col justify-center gap-0 text-gray-600 font-normal">

      {props.type !== "file" ? (

        props.type==="textarea"?
        <label className={` ${props.className ? props.className : "py-3"} `}>
          {label}
          {required && <span className="text-red-500 required-dot">*</span>}
          <textarea
            {...field}
            {...props}
            className={`${desable ? "bg-gray-500" : ""} w-full bg-white rounded-md py-2 px-3 text-gray-500 shadow-md focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-500`}
            disabled={desable}
          />
        </label>:

         <label className={` ${props.className ? props.className : "py-3"} `}>
          {label}
          {required && <span className="text-red-500 required-dot">*</span>}
          <Input
            {...field}
            {...props}
            className={`${desable ? "!bg-gray-50 !shadow-none" : ""} ${inputClass}`}
            disabled={desable}
          />
        </label>
      ) : (
        <label className="py-3 col-span-2">
          {label}
          {required && <span className="text-red-500 required-dot">*</span>}
          <Input
            // {...field}
            placeholder="Select file"
            onChange={handleFileChange}
            {...props}
            id="dropzone-file"
            style={{
              ...props.type="file" && { visibility: "hidden"}
            }}
            // className={`${desable ? "bg-gray-500" : ""}`}
            className="hidden"
            disabled={desable}
          />
          
          <ViewFileArea
          deleteFile={deleteFile}
          uploadProgress={uploadProgress}
          onChange={handleFileChange}
          className="w-full flex flex-col w-[100vh] h-full"
          {...props}
          files={files}
          isLoading={isLoading}
          />
        </label>
      )}

      {meta.touched && meta.error ? (
        <p className="text-red-500 font-normal">*{meta.error}</p>
      ) : null}
    </div>
  );
};

export default InputField;
